import { LocaleEnum } from 'shared/enums/locale-enum'

export const getFacebookLink = (
  locale?: LocaleEnum,
):
  | 'https://web.facebook.com/groups/296372101671752'
  | 'https://www.facebook.com/get.systeme.io/'
  | 'https://www.facebook.com/groups/251145835476950'
  | 'https://www.facebook.com/groups/713654809865183'
  | 'https://www.facebook.com/groups/819816168641637'
  | 'https://www.facebook.com/groups/systemeio/'
  | 'https://www.facebook.com/groups/systemeioportuguese'
  | 'https://www.facebook.com/groups/systemeiospanish' => {
  switch (locale) {
    case LocaleEnum.FRENCH: {
      return 'https://www.facebook.com/groups/systemeio/'
    }
    case LocaleEnum.SPANISH: {
      return 'https://www.facebook.com/groups/systemeiospanish'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://web.facebook.com/groups/296372101671752'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://www.facebook.com/groups/systemeioportuguese'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://www.facebook.com/groups/819816168641637'
    }
    case LocaleEnum.DUTCH: {
      return 'https://www.facebook.com/groups/713654809865183'
    }
    case LocaleEnum.RUSSIAN: {
      return 'https://www.facebook.com/get.systeme.io/'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://www.facebook.com/groups/251145835476950'
    }
    default: {
      return 'https://www.facebook.com/groups/251145835476950'
    }
  }
}

export const getTwitterLink = (
  locale?: LocaleEnum,
): 'https://twitter.com/systeme_io' | 'https://twitter.com/systemeio_FR' => {
  switch (locale) {
    case LocaleEnum.FRENCH: {
      return 'https://twitter.com/systemeio_FR'
    }
    default: {
      return 'https://twitter.com/systeme_io'
    }
  }
}

export const getLinkedinLink = (locale?: LocaleEnum): string => {
  switch (locale) {
    default: {
      return 'https://www.linkedin.com/company/getsystemeio/'
    }
  }
}

export const getInstagramLink = (
  locale?: LocaleEnum,
):
  | 'https://www.instagram.com/get.systeme.io/'
  | 'https://www.instagram.com/systeme.io_es/'
  | 'https://www.instagram.com/systeme.io/?hl=fr' => {
  switch (locale) {
    case LocaleEnum.FRENCH: {
      return 'https://www.instagram.com/systeme.io/?hl=fr'
    }
    case LocaleEnum.SPANISH: {
      return 'https://www.instagram.com/systeme.io_es/'
    }
    default: {
      return 'https://www.instagram.com/get.systeme.io/'
    }
  }
}

export const getYoutubeLink = (
  locale?: LocaleEnum,
):
  | 'https://www.youtube.com/channel/UCraPZlriFy_ltGgo7dwQexw'
  | 'https://www.youtube.com/channel/UCsctiHCCajKHfy9RI0Mve8g' => {
  switch (locale) {
    case LocaleEnum.SPANISH: {
      return 'https://www.youtube.com/channel/UCsctiHCCajKHfy9RI0Mve8g'
    }
    default: {
      return 'https://www.youtube.com/channel/UCraPZlriFy_ltGgo7dwQexw'
    }
  }
}
